// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2bPAa","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1uviy","obliqueLine":"membershipbadge_obliqueLine__1Ndjv"};